import { fromJS } from 'immutable';

export function request(state) {
    return state.set('bannerConfig', fromJS({
        status: 'IN_PROGRESS'
    }));
}

export function finish(state, { data }) {
    return state.set('bannerConfig', fromJS({
        status: 'FINISHED',
        data: data
    }));
}

export function error(state) {
    return state.set('bannerConfig', fromJS({
        status: 'ERROR'
    }));
}
